<template>
  <a-modal :visible="showDialog" :mask="true" :maskClosable="false" :title="title" @ok="handleOk"
    @cancel="handleCancel()">
    <a-form layout="vertical">
      <a-form-item label="名称">
        <a-input v-model="dataInfo.name" />
      </a-form-item>
      <a-form-item label="备注">
        <a-textarea :rows="4" v-model="dataInfo.remarks" />
      </a-form-item>

    </a-form>
  </a-modal>
</template>
<script>
import { ConfigTypeSave } from "../../api/v1/config_api";

export default {
  name: "ConfigTypeEditDialog",
  props: ['showDialog', 'dataInfo', 'title'],
  data() {
    return {
    }
  },
  methods: {
    handleOk() {
      if (!this.dataInfo.name) {
        this.$message.error('请输入分类名称')
        return
      }
      ConfigTypeSave(this.dataInfo).then(resp => {
        if (resp.code === 200) {
          this.$message.success(resp.msg)
          this.$emit('close-dialog')
        } else {
          this.$message.error(resp.msg)
        }
      })
    },
    handleCancel() {
      this.$emit('close-dialog')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/V1/ConfigTypeEditDialog.vue